const copy = {
  helpText: {
    characterLimit: (characterLimit: number, characterCount: number): string =>
      `${characterCount}/${characterLimit} characters`,
  },
  errors: {
    characterLimit: (
      characterLimit: number,
      characterCount: number
    ): string => {
      const extraCharacters = characterCount - characterLimit;
      return `Please reduce character count by ${extraCharacters}.`;
    },
    default: (name?: string): string => `Please enter a ${name || "value"}`,
  },
};

export default copy;
